import { TypesTravail } from '@/enum/AAT.enum';

export class TempsTravail {
	type: TypesTravail;

	constructor(
		type: TypesTravail = TypesTravail.TEMPS_COMPLET
	) {
		this.type = type;
	}
}

export interface TempsTravailState {
	tempsTravail?: TempsTravail;
}
